module.exports = "//static.hsappstatic.net/ecosystem-marketplace-apps-base/static-1.4198/img/video-thumb-overlay.png"